"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailRegistrationForm = EmailRegistrationForm;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _InputField = require("../InputField");
var _PasswordField = require("../PasswordField");
var _FieldGroupLayout = require("../FieldGroupLayout");
var _ContentLayout = require("../ContentLayout");
var _keyCodes = require("../../types/keyCodes");
var styles = _interopRequireWildcard(require("./styles.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function EmailRegistrationForm(props) {
  const {
    handleSubmit
  } = props;
  const handlePreventSubmit = React.useCallback(e => {
    e.preventDefault();
  }, []);
  const handleSubmitOnEnter = React.useCallback(e => {
    if (e.keyCode === _keyCodes.EKeyCode.Enter) {
      handleSubmit();
    }
  }, [handleSubmit]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles['title']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading3, null, "\u041F\u0440\u0438\u0434\u0443\u043C\u0430\u0439\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C")), /*#__PURE__*/React.createElement(_ContentLayout.ContentLayout, null, /*#__PURE__*/React.createElement("form", {
    onSubmit: handlePreventSubmit
  }, /*#__PURE__*/React.createElement(_FieldGroupLayout.FormFieldGroupLayout, {
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_InputField.InputField, {
      "data-name": "EmailIdInput",
      name: "username",
      id: "username",
      autoComplete: "off",
      autoFocus: !props.autoFocusDisabled,
      disabled: props.isSubmitting,
      value: props.login,
      required: true,
      ref: props.loginRef,
      invalid: props.isLoginInvalid,
      errorMessage: props.loginError,
      onKeyDown: handleSubmitOnEnter,
      onChange: props.onLoginChange,
      type: "text",
      placeholder: "Email \u0438\u043B\u0438 id"
    }), /*#__PURE__*/React.createElement(_PasswordField.PasswordField, {
      name: "password",
      id: "password",
      hidden: false,
      tabIndex: 0,
      placeholder: "\u041F\u0430\u0440\u043E\u043B\u044C",
      autoComplete: 'new-password',
      value: props.password,
      required: true,
      ref: props.passwordRef,
      invalid: props.isPasswordInvalid,
      disabled: props.isSubmitting,
      onChange: props.onPasswordChange,
      onKeyDown: handleSubmitOnEnter,
      errorMessage: props.passwordError,
      passwordShown: props.passwordShown,
      toggleVisibility: props.togglePasswordVisibility
    }), !props.passwordError && /*#__PURE__*/React.createElement(_uiKit.UIText3, {
      color: "black_60",
      "data-testid": "addon"
    }, "\u041E\u0442 8 \u0434\u043E 30 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432")),
    buttons: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_uiKit.Button, {
      "data-name": "ContinueAuthBtn",
      onClick: handleSubmit,
      fullWidth: true
    }, "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C"))
  }))));
}